export type OnTimedPromise = (name: string, time: number) => void;

/**
 * Measures the time taken for a promise to resolve or reject and calls a provided callback with that duration.
 * @param onTimed Called with promiseName and the elapsed milliseconds once the promise settles.
 * @example
 * const myPromise = new Promise((resolve) => setTimeout(() => resolve("Done"), 2000));
 * await timePromise("MyPromise", myPromise, (name, duration) => {
 *     console.log(`${name} took ${duration}ms to complete.`);
 * });
 */
export async function timePromise<T>(
    promiseName: string,
    inputPromise: Promise<T>,
    onTimed: OnTimedPromise
): Promise<T> {
    const startTime = performance.now();
    try {
        const result = await inputPromise;
        onTimed(promiseName, performance.now() - startTime);
        return result;
    } catch (error: unknown) {
        onTimed(promiseName, performance.now() - startTime);
        throw error;
    }
}
